module.exports = __webpack_public_path__ + "static/media/dianrelan_banner5_officebuilding.4c7904d5.png";